import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const { UNDO_DOCUMENT_SIGN_SUCCESS, UNDO_DOCUMENT_SIGN_REQUEST, UNDO_DOCUMENT_SIGN_FAILURE } =
  documentationActions;

function* undoDocumentSign(action: any): SagaReturnType<any> {
  try {
    const response = yield call(templateService.undoDocSignatureFlow, action.payload);
    if (response?.status === 200) {
      yield put({ type: UNDO_DOCUMENT_SIGN_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: UNDO_DOCUMENT_SIGN_FAILURE, payload: error });
  }
}

function* undoDocumentSignSaga() {
  yield takeEvery(UNDO_DOCUMENT_SIGN_REQUEST, undoDocumentSign);
}

export default undoDocumentSignSaga;
